// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reset-password-modal-modal_card-UpJwS {
  width: 340px;
  height: auto;
  min-height: auto;
}

.reset-password-modal-toolbar_container-wIfBD {
  border-bottom: none;
}

.reset-password-modal-toolbar_title-xY3tX {
  font-size: 16px;
}

.reset-password-modal-content-L_YcM {
  font-size: 15px;
  font-weight: 400;
  color: var(--color-neutral-800);
  padding-bottom: 12px;
}

.reset-password-modal-content-L_YcM b {
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/pages/customer/customer-user/reset-password-modal/reset-password-modal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".modal_card {\n  width: 340px;\n  height: auto;\n  min-height: auto;\n}\n\n.toolbar_container {\n  border-bottom: none;\n}\n\n.toolbar_title {\n  font-size: 16px;\n}\n\n.content {\n  font-size: 15px;\n  font-weight: 400;\n  color: var(--color-neutral-800);\n  padding-bottom: 12px;\n}\n\n.content b {\n  font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_card": `reset-password-modal-modal_card-UpJwS`,
	"toolbar_container": `reset-password-modal-toolbar_container-wIfBD`,
	"toolbar_title": `reset-password-modal-toolbar_title-xY3tX`,
	"content": `reset-password-modal-content-L_YcM`
};
export default ___CSS_LOADER_EXPORT___;
